module.exports = __webpack_public_path__ + "static/media/dogenano-discord-2.90151f8c.png";